// extracted by mini-css-extract-plugin
export default {"root":"ProductList_root__i7x6R","header":"ProductList_header__hyKAW","searchInput":"ProductList_searchInput__nsBQ2","headerButtons":"ProductList_headerButtons__cTd2Z"};